import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IParticipantModel } from 'models/participant.model'
import { ParticipantCourses } from 'models/participantCourse.model'
import { IUserModel } from 'models/user.model'

export const PARTICIPANTS_PROFILES_LIST = 'PARTICIPANTS_PROFILES_LIST'
export const PARTICIPANTS_PROFILES_LIST_SUCCESS =
  'PARTICIPANTS_PROFILES_LIST_SUCCESS'
export const PARTICIPANTS_PROFILES_DESTROY = 'PARTICIPANTS_PROFILES_DESTROY'
export const PARTICIPANTS_PROFILES_DESTROY_SUCCESS =
  'PARTICIPANTS_PROFILES_DESTROY_SUCCESS'
export const PARTICIPANTS_PROFILES_GET = 'PARTICIPANTS_PROFILES_GET'
export const PARTICIPANTS_PROFILES_GET_SUCCESS =
  'PARTICIPANTS_PROFILES_GET_SUCCESS'
export const PARTICIPANTS_DOWNLOAD = 'PARTICIPANTS_DOWNLOAD'
export const PARTICIPANTS_DOWNLOAD_SUCCESS = 'PARTICIPANTS_DOWNLOAD_SUCCESS'
export const PARTICIPANTS_GET_COURSES = 'PARTICIPANTS_GET_COURSES'
export const PARTICIPANTS_GET_COURSES_SUCCESS =
  'PARTICIPANTS_GET_COURSES_SUCCESS'
export const PARTICIPANT_EDIT_PROFILES = 'PARTICIPANT_EDIT_PROFILES'
export const PARTICIPANT_EDIT_PROFILES_SUCCESS =
  'PARTICIPANT_EDIT_PROFILES_SUCCESS'
export const PARTICIPANT_EDIT_SUPERVISORS_SUCCESS =
  'PARTICIPANT_EDIT_SUPERVISORS_SUCCESS'
export const PARTICIPANT_EDIT_ROLE = 'PARTICIPANT_EDIT_ROLE'
export const PARTICIPANT_EDIT_ROLE_SUCCESS = 'PARTICIPANT_EDIT_ROLE_SUCCESS'
export const RESET_COURSE = 'RESET_COURSE'
export const GET_ROLE_BY_USERID = 'GET_ROLE_BY_USERID'
export const GET_ROLE_BY_USERID_SUCCESS = 'GET_ROLE_BY_USERID_SUCCESS'
export const REMOVE_PROFILES_BULK_ACTION = 'REMOVE_PROFILES_BULK_ACTION'
export const REMOVE_PROFILES_BULK_ACTION_SUCCESS =
  'REMOVE_PROFILES_BULK_ACTION_SUCCESS'
export const ADD_PROFILES_BULK_ACTION = 'ADD_PROFILES_BULK_ACTION'
export const ADD_PROFILES_BULK_ACTION_SUCCESS =
  'ADD_PROFILES_BULK_ACTION_SUCCESS'
export const PARTICIPANTS_INACTIVE_PROFILES_LIST =
  'PARTICIPANTS_INACTIVE_PROFILES_LIST'
export const PARTICIPANTS_INACTIVE_PROFILES_LIST_SUCCESS =
  'PARTICIPANTS_INACTIVE_PROFILES_LIST_SUCCESS'
export const PARTICIPANTS_SET_ACTIVE = 'PARTICIPANTS_SET_ACTIVE'
export const PARTICIPANTS_IDS_LIST = 'PARTICIPANT_IDS_LIST'
export const PARTICIPANTS_IDS_LIST_SUCCESS = 'PARTICIPANT_IDS_LIST_SUCCESS'

export const Actions = {
  participantsProfilesList: (payload: any) =>
    createAction(PARTICIPANTS_PROFILES_LIST, payload),
  participantsProfilesListSuccess: (
    data: IParticipantModel,
    total: number,
    perPage: number,
    sort: any[]
  ) =>
    createAction(PARTICIPANTS_PROFILES_LIST_SUCCESS, {
      data,
      total,
      perPage,
      sort,
    }),
  participantsProfilesDestroySuccess: (data: number) =>
    createAction(PARTICIPANTS_PROFILES_DESTROY_SUCCESS, data),
  participantsProfilesReload: () => createAction(PARTICIPANTS_PROFILES_LIST),
  participantGet: (userId: number) =>
    createAction(PARTICIPANTS_PROFILES_GET, userId),
  participantGetSuccess: (data: IParticipantModel) =>
    createAction(PARTICIPANTS_PROFILES_GET_SUCCESS, data),
  participantDownloadSuccess: (data: string) =>
    createAction(PARTICIPANTS_DOWNLOAD_SUCCESS, data),
  participantGetCourses: (userId: number) =>
    createAction(PARTICIPANTS_GET_COURSES, userId),
  participantGetCoursesSuccess: (data: ParticipantCourses) =>
    createAction(PARTICIPANTS_GET_COURSES_SUCCESS, data),
  participantEditProfiles: (userId: number, data: any) =>
    createAction(PARTICIPANT_EDIT_PROFILES, { userId, data }),
  participantEditProfilesSuccess: (data: any) =>
    createAction(PARTICIPANT_EDIT_PROFILES_SUCCESS, data),
  participantEditSupervisorsSuccess: (data: IUserModel[]) =>
    createAction(PARTICIPANT_EDIT_SUPERVISORS_SUCCESS, data),
  participantEditRole: (userId: number, roleId: number) =>
    createAction(PARTICIPANT_EDIT_ROLE, { userId, roleId }),
  participantEditRoleSuccess: (roleId: number) =>
    createAction(PARTICIPANT_EDIT_ROLE_SUCCESS, { roleId }),
  resetCourse: (userId: number, courseId: number) =>
    createAction(RESET_COURSE, { userId, courseId }),
  participantGetRoleById: (userId: number) =>
    createAction(GET_ROLE_BY_USERID, userId),
  participantGetRoleByIdSuccess: (data: any) =>
    createAction(GET_ROLE_BY_USERID_SUCCESS, data),
  participantsRemoveProfiles: (ids: number[], listConfig: any) =>
    createAction(REMOVE_PROFILES_BULK_ACTION, { ids, listConfig }),
  participantsAddProfiles: (
    ids: number[],
    profilesIds: number[],
    listConfig: any
  ) => createAction(ADD_PROFILES_BULK_ACTION, { ids, profilesIds, listConfig }),
  participantsInactiveProfilesList: (payload: any) =>
    createAction(PARTICIPANTS_INACTIVE_PROFILES_LIST, payload),
  participantsInactiveProfilesListSuccess: (
    data: IParticipantModel,
    total: number,
    perPage: number,
    sort: any[]
  ) =>
    createAction(PARTICIPANTS_INACTIVE_PROFILES_LIST_SUCCESS, {
      data,
      total,
      perPage,
      sort,
    }),
  participantsSetActive: (
    origin: number,
    ids: number[],
    state: boolean,
    listConfig: any
  ) =>
    createAction(PARTICIPANTS_SET_ACTIVE, { origin, ids, state, listConfig }),
  participantsIdsList: (payload: any) =>
    createAction(PARTICIPANTS_IDS_LIST, payload),
  participantsIdsListSuccess: (data: any) =>
    createAction(PARTICIPANTS_IDS_LIST_SUCCESS, { data }),
}

export type Actions = ActionsUnion<typeof Actions>
